import { render } from "./ViewWrapper.vue?vue&type=template&id=63148c60"
import script from "./ViewWrapper.vue?vue&type=script&lang=js"
export * from "./ViewWrapper.vue?vue&type=script&lang=js"

import "./ViewWrapper.vue?vue&type=style&index=0&id=63148c60&lang=scss"

import exportComponent from "/app/tmp/rd/V3/v2026.32.r0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__